import { isArray, isPlainObject, cloneDeep, mapKeys, mapValues, camelCase, snakeCase } from 'lodash';

export function keysToCamelCase(object) {
  if (!isPlainObject(object) && !isArray(object)) {
    return object;
  }

  let camelCaseObject = cloneDeep(object);

  if (isArray(camelCaseObject)) {
    return camelCaseObject.map(keysToCamelCase);
  }

  camelCaseObject = mapKeys(camelCaseObject, (value, key) => camelCase(key));

  return mapValues(camelCaseObject, (value) => {
    if (isPlainObject(value)) {
      return keysToCamelCase(value);
    }
    else if (isArray(value)) {
      return value.map(keysToCamelCase);
    }
    return value;
  });
}

export function keysToSnakeCase(object) {
  if (!isPlainObject(object) && !isArray(object)) {
    return object;
  }

  let snakeCaseObject = cloneDeep(object);

  if (isArray(snakeCaseObject)) {
    return snakeCaseObject.map(keysToSnakeCase);
  }

  snakeCaseObject = mapKeys(snakeCaseObject, (value, key) => snakeCase(key));

  return mapValues(snakeCaseObject, (value) => {
    if (isPlainObject(value)) {
      return keysToSnakeCase(value);
    }
    else if (isArray(value)) {
      return value.map(keysToSnakeCase);
    }
    return value;
  });
}
